<template>
  <div class="authorization-form">
    <div class="mb-40">
      <vl-breadcrumbs :items="breadcrumbsData" />
    </div>
    <h3 class="h3-title">
      {{ t[locale]['authorization.login.h3_enter_data'] }}
    </h3>
    <validation-observer ref="form" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(login)" autocomplete="off">
        <div class="mb-3">
          <validation-provider rules="required" v-slot="{ errors, failed }" vid="email" tag="div">
            <vl-input-text
              class="authorization-form__input"
              :label="t[locale]['authorization.login.email']"
              type="email"
              name="user[email]"
              v-model="loginData.email"
              :error="failed"
            />
            <span class="error-message">{{ errors[0] }}</span>
          </validation-provider>
        </div>
        <div class="mb-3">
          <validation-provider vid="password" rules="required" v-slot="{ errors, failed }" tag="div">
            <vl-input-text
              class="authorization-form__input"
              :label="t[locale]['authorization.login.password']"
              type="password"
              name="user[password]"
              v-model="loginData.password"
              :error="failed"
            />
            <span class="error-message">{{ errors[0] }}</span>
          </validation-provider>
        </div>
        <div class="d-flex flex-column align-items-start mb-3">
          <a class="login-form__url" :href="resetPasswordRouter()">
            {{ t[locale]['authorization.login.forgot_password_or_login'] }}
          </a>
          <a class="login-form__url" :href="registrationRouter()">
            {{ t[locale]['authorization.login.not_registration'] }}
          </a>
        </div>
        <div class="d-flex">
          <vl-button type="primary" size="small" actionType="submit" :loading="loadingButton">
            {{ t[locale]['authorization.login.signin_short'] }}
          </vl-button>
        </div>
      </form>
    </validation-observer>
  </div>
</template>
<script>
import VlBreadcrumbs from '@components/@oschad/ui/vl-breadcrumbs'
import VlButton from '@components/@oschad/ui/vl-button'
import VlInputText from '@components/@oschad/ui/vl-input-text'
import checkErrors from '@javascript/mixins/checkErrors'
import locales from './locales'
import main from '../main'

export default {
  name: 'Login',
  components: {
    VlButton,
    VlInputText,
    VlBreadcrumbs,
  },
  mixins: [main],
  data: () => ({
    t: locales,
  }),
}
</script>
